import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import tc from 'tinycolor2';
import AccessibilityLinks from './AccessibilityLinks';
import HeaderPromoBanner from '../HeaderPromoBanner';
import CourtesyNav from './CourtesyNav';
import HeaderLogo from './HeaderLogo';
import DesktopNav from './DesktopNav';
import SearchToggle from './SearchToggle';
import { colors } from '../../styles';

const styles = css`
  position: absolute;
  width: 100%;
  z-index: 50;
  &::after {
    content: '';
    display: none;
    position: absolute;
    width: 100vw;
    height: 500px;
    right: 0;
    bottom: 80px;
    background-color: ${tc(colors.brand2).setAlpha(0.6).toRgbString()};
    transform: skewY(11deg);
  }
  .MainNav {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    transition: all .3s ease;
    @media (min-width: 1200px) {
      margin: 45px 0 0 0;
      padding: 25px 25px 25px 0;
      background-color: transparent;
    }
    @media (min-width: 1600px) {
      padding: 25px 65px 25px 0;
    }
  }
  &.HeaderAlt {
    .MainNav {
      @media (min-width: 992px) {
        position: fixed;
        top: 0;
        left: 0;
        margin: 0;
        background-color: ${tc(colors.brand4Darker).setAlpha(0.95).toRgbString()};
        height: 80px;
      }
      @media (min-width: 1200px) {
        padding: 5px 25px 5px 0;
      }
      @media (min-width: 1600px) {
        padding: 5px 60px 5px 0;
      }
    }
    .HeaderLogo {
      @media (min-width: 992px) {
        img {
          height: 60px !important;
        }
        top: 5px;
      }
      @media (min-width: 1200px) {
        top: 15px !important;
      }
    }
    .CourtesyNav {
      justify-content: center;
      width: 500px;
      margin: 0;
      padding: 0;
      left: 44%;
      animation: navFadeIn 1s;
      animation-iteration-count: 1;
      transform: translateX(-50%);
      opacity: 1;
      @media (min-width: 1350px) {
        left: 50%;
      }
      @media (min-width: 1600px) {
        width: fit-content;
      }
      &::after {
        display: none;
      }
      .CourtesyNav_itemLink {
        height: 70px;
      }
    }
    @keyframes navFadeIn {
      0% {
        opacity: 1;
      }
      1% {
        opacity: 0;
        transform: translateX(0);
      }
      49% {
        transform: translateX(-50%);
      }
      50% {
        opacity: 0;
      }
      100% {
        opacity: 1;
        transform: translateX(-50%);
      }
    }
  }
`;

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      headerAlt: true,
    };
    this.lastScroll = 0;
  }
  componentDidMount() {
    this.scrollWatcher = setInterval(() => {
      if (this.lastScroll !== window.pageYOffset) {
        this.handleScroll();
      }
    }, 100);
  }

  componentWillUnmount() {
    clearInterval(this.scrollWatcher);
  }
  onScroll = headerAlt => {
    this.setState({ headerAlt });
  }

  handleScroll = () => {
    this.lastScroll = window.pageYOffset;
    const headerAlt = this.lastScroll < 50;
    if (headerAlt !== this.state.headerAlt) {
      this.onScroll(headerAlt);
    }
    this.lastRun = Date.now();
  }

  render() {
    const { widget } = this.props;
    const { headerAlt } = this.state;
    return (
      <header className={`${styles} ${!headerAlt && 'HeaderAlt'}`}>
        <AccessibilityLinks />
        <HeaderPromoBanner />
        {
          get(widget, 'header_options[0].show_courtesy_nav') &&
          <CourtesyNav />
        }
        <div className="MainNav">
          <HeaderLogo className="HeaderLogo" />
          {
            get(widget, 'header_options[0].show_desktop_nav') &&
            <DesktopNav />
          }
          {
            get(widget, 'header_options[0].show_search_button') &&
            <SearchToggle />
          }
        </div>
      </header>
    );
  }
}

Header.propTypes = {
  widget: PropTypes.object.isRequired,
};

export default withData(
  {
    widget: 'website_configuration',
  },
)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/index.js